'use strict'

import format from 'string-format'
import session from './session'

export default {

	probePlex_list(project_id) {

		const params = {}
		if (project_id) {
			// фильтр Django
			params['projects_id'] = project_id
		}

		return session.get('probePlex/', {params: params})
	},

	probePlex_update(probePlex, details = true) {
		return session.request({
			method: 'PATCH',
			url: format('/probePlex/{id}/', {id: probePlex.id}),
			data: probePlex,
		})
	},

	/**
	 * Обновить источники спектра для зонда мультиплекса
	 * @param ppp          зонд мультиплекса
	 * @param plate_wells  планшеты со списком лунок [ { plate: {id, }, plate_wells: []}, ...]
	 * @returns {Promise<AxiosResponse<any>>}
	 */
	ppp_update_spectra_source(ppp, plate_wells) {
		return session.request({
			method: 'POST',
			url: format(
				'/probePlex/{pp_id}/ppp/{ppp_id}/update_spectra_source/',
				{pp_id: ppp.probePlex.id, ppp_id: ppp.id,}),
			data: {plate_wells,},
		})
	},
}